import { useIntl } from 'react-intl';
import printIcon from '../../assets/icons/print.svg';
import documentDownloadIcon from '../../assets/icons/documents-downloadall-small-icon.svg';
import s from './PageActions.module.scss';

interface PageActionsProps {
  download: string;
}

/**
 * page actions component
 */
function PageActions({ download }: PageActionsProps) {
  const intl = useIntl();
  return (
    <span className={s.pageActionsContainer}>
      <button
        type="button"
        className={`btn btn-sm ${s.printButtonImprint}`}
        onClick={() => window.print()}
        title={intl.formatMessage({ id: 'printSite' })}
      >
        <img src={printIcon} alt={intl.formatMessage({ id: 'printSite' })} />
      </button>
      <a href={download}>
        <button
          type="button"
          className={`btn btn-sm ${s.downloadButtonImprint}`}
          title={intl.formatMessage({ id: 'downloadPDF' })}
        >
          <img
            src={documentDownloadIcon}
            alt={intl.formatMessage({ id: 'downloadPDF' })}
          />
        </button>
      </a>
    </span>
  );
}

export default PageActions;
